import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { MonthlyReportModel } from "./models/MonthlyReportModel";

export type UploadMonthlyReportsRequest = {
  file: File;
  documentYear: number;
};

export type UploadMonthlyReportsResponse = {
  monthlyReport: MonthlyReportModel;
};

export const uploadMonthlyReport = async (request: UploadMonthlyReportsRequest) => {
  const formData = new FormData();
  formData.append("file", request.file);
  formData.append("documentYear", request.documentYear.toString());
  const response = await executeApiRequest(() => axios.post<UploadMonthlyReportsResponse>("/monthlyReports", formData), false);

  return response?.data.monthlyReport;
};
